// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3zXmn","title":"Header_title__1HAbu","side":"Header_side__3VRJm"};